// tslint:disable
export var CampaignCommunicationType;
(function (CampaignCommunicationType) {
    // UNKN
    CampaignCommunicationType[CampaignCommunicationType["UNKN"] = 10001] = "UNKN";
    // SMS
    CampaignCommunicationType[CampaignCommunicationType["SMS"] = 10002] = "SMS";
    // EMAIL
    CampaignCommunicationType[CampaignCommunicationType["EMAIL"] = 10003] = "EMAIL";
    // PHOUT
    CampaignCommunicationType[CampaignCommunicationType["PHOUT"] = 10004] = "PHOUT";
    // PHIN
    CampaignCommunicationType[CampaignCommunicationType["PHIN"] = 10005] = "PHIN";
    // FAX
    CampaignCommunicationType[CampaignCommunicationType["FAX"] = 10006] = "FAX";
    // LETTER
    CampaignCommunicationType[CampaignCommunicationType["LETTER"] = 10007] = "LETTER";
    // SMS24
    CampaignCommunicationType[CampaignCommunicationType["SMS24"] = 10008] = "SMS24";
    // PDF
    CampaignCommunicationType[CampaignCommunicationType["PDF"] = 10009] = "PDF";
    // 20166
    CampaignCommunicationType[CampaignCommunicationType["Two0166"] = 10010] = "Two0166";
    // DocumentSend
    CampaignCommunicationType[CampaignCommunicationType["DocumentSend"] = 10011] = "DocumentSend";
    // DataFeed
    CampaignCommunicationType[CampaignCommunicationType["DataFeed"] = 10012] = "DataFeed";
    // MANGO
    CampaignCommunicationType[CampaignCommunicationType["MANGO"] = 10013] = "MANGO";
    // TC-Script
    CampaignCommunicationType[CampaignCommunicationType["TCScript"] = 10014] = "TCScript";
    // Physical_Collateral
    CampaignCommunicationType[CampaignCommunicationType["PhysicalCollateral"] = 10015] = "PhysicalCollateral";
    // PDFToFolder
    CampaignCommunicationType[CampaignCommunicationType["PDFToFolder"] = 10016] = "PDFToFolder";
    // SimulatedSMS
    CampaignCommunicationType[CampaignCommunicationType["SimulatedSMS"] = 10017] = "SimulatedSMS";
})(CampaignCommunicationType || (CampaignCommunicationType = {}));
CampaignCommunicationType['TWO0166'] = 10010;
CampaignCommunicationType['DOCUMENTSEND'] = 10011;
CampaignCommunicationType['DATAFEED'] = 10012;
CampaignCommunicationType['TCSCRIPT'] = 10014;
CampaignCommunicationType['PHYSICALCOLLATERAL'] = 10015;
CampaignCommunicationType['PDFTOFOLDER'] = 10016;
CampaignCommunicationType['SIMULATEDSMS'] = 10017;
//# sourceMappingURL=CampaignCommunicationType.js.map